import { makeInt64DataField, makeStringDataField } from '../DataFieldHelper';
import { addContractField } from '../Contract';
export var Error;
(function (Error) {
    var contractName = 'Office.System.Error';
    /**
     * Gets data fields for the Error Contract
     * @param instanceName - The instance name of this Error Contract
     * @param contract - The object containing data fields pertaining to the Error Contract
     */
    function getFields(instanceName, contract) {
        var dataFields = [];
        dataFields.push(makeStringDataField(instanceName + ".ErrorGroup", contract.errorGroup));
        dataFields.push(makeInt64DataField(instanceName + ".Tag", contract.tag));
        if (contract.code !== undefined) {
            dataFields.push(makeInt64DataField(instanceName + ".Code", contract.code));
        }
        if (contract.id !== undefined) {
            dataFields.push(makeInt64DataField(instanceName + ".Id", contract.id));
        }
        if (contract.count !== undefined) {
            dataFields.push(makeInt64DataField(instanceName + ".Count", contract.count));
        }
        addContractField(dataFields, instanceName, contractName);
        return dataFields;
    }
    Error.getFields = getFields;
})(Error || (Error = {})); // Error
//# sourceMappingURL=Office.System.Error.js.map